import { api } from '../initFetch'

export const getJobHistoryOverview = async (req) => {
  const res = await api.post('/p4m/Document/GetJobHistoryOverview', req)
  return res.json
}
